import { useState, useEffect } from 'react';
// @form
import { useController, UseControllerProps, FieldValues, FieldPath } from 'react-hook-form';
// assets
import { ReactComponent as Check } from '../../assets/form/check.svg';
// styles
import { Label, PasswordFields, RequisiteWrapper, Requisite, Message } from './styles';

// ----------------------------------------------------------------------

interface Props extends React.InputHTMLAttributes<HTMLInputElement>{
  label: string;
};

// ----------------------------------------------------------------------

const PasswordField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name, control, label, ...other
}: Props & UseControllerProps<TFieldValues, TName>) => {

  const {
    field,
    fieldState: { error: invalid }
  } = useController({
    name,
    control
  });

  const [ error, setError ] = useState(false);

  useEffect(() => {
    if ( invalid ) {
      if ( name === 'password' && invalid.type !== 'required' ) return setError(false);
      return setError(true); 
    }
    setError(false); 
  }, [invalid]);

  const [ english, setEnglish ] = useState(false);
  const [ number, setNumber ] = useState(false);
  const [ character, setCharacter ] = useState(false);
  const [ length, setLength ] = useState(false);

  const [ type, setType ] = useState('password');

  useEffect(() => {
    const value = field.value;

    if ( /[a-zA-Z]/.test(value) ) setEnglish(true);
    else setEnglish(false);
    if ( /[0-9]/.test(value) ) setNumber(true);
    else setNumber(false);
    // eslint-disable-next-line
    if ( /[\~\!\@\#\$\%\^\&\*\(\)\+\|\=]/.test(value) ) setCharacter(true);
    else setCharacter(false);
    if ( value?.length > 7 && value?.length < 17 ) setLength(true);
    else setLength(false);
  }, [field.value]);

  return (
    <div>
      <Label>{ label }</Label>

      <PasswordFields $error={error} $icon={type === 'text' ? 'eye-open' : 'eye-closed'}>
        <input type={type} {...other} {...field} />
        <button type='button' onClick={() => type === 'text' ? setType('password') : setType('text') } />
      </PasswordFields>

      { name === 'new' &&
        <RequisiteWrapper>
          <Requisite $check={english ? true : false}><Check />영어 대소문자</Requisite>
          <Requisite $check={number ? true : false}><Check />숫자</Requisite>
          <Requisite $check={character ? true : false}><Check />특수문자 !@&()-_+[]{}.</Requisite>
          <Requisite $check={length ? true : false}><Check />8~16자</Requisite>
        </RequisiteWrapper>
      }

      { invalid && invalid.type !== 'required' && invalid.type !== 'typeError' && name !== 'password' &&
        <Message>{ invalid.message }</Message>
      }
    </div>
  );
};

export default PasswordField;